import type { NextRouter } from "next/router";
import type { CustomerLoginRouterScope } from "@Front/Components/Layouts/Login/helpers/customerLoginRouterScope";
import type { CustomerLoginState } from "@Front/Components/Layouts/Login/hooks/helpers/loginStateHook";
import { useAssembledLoginPasswordHandlers } from "@Front/Components/Layouts/Login/hooks/helpers/loginPasswordFlowAssembly";

export function useLoginPasswordFlowHandlers(params: {
	router: NextRouter;
	loginScope: CustomerLoginRouterScope;
	loginState: CustomerLoginState;
	refresh: () => Promise<void>;
}): {
	onNewPasswordSubmit: (e: React.FormEvent<HTMLFormElement> | null, values: Record<string, string>) => Promise<void>;
	onPasswordSubmit: (e: React.FormEvent<HTMLFormElement> | null, values: Record<string, string>) => Promise<void>;
	onPasswordForgotClicked: () => void;
	onSendAnotherCode: () => void;
} {
	return useAssembledLoginPasswordHandlers(params);
}
